import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileFill.tsx
const IconFileFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m4 10.667 8.004-8h14.66A1.34 1.34 0 0 1 28 3.989v24.022c0 .73-.593 1.322-1.325 1.322H5.325c-.732 0-1.325-.6-1.325-1.342zm9.333-6L6 12h7.333z"
	})]
});
var IconFileFill_default = forwardRef(IconFileFill);
//#endregion
export { IconFileFill_default as default };
